<template>
  <div class="Audit">
    <router-view />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Audit"
};
</script>